import { getData } from '../utils/ajax-utils';

export function initMyOrdersAjaxLoad() : void {
    document.querySelectorAll<HTMLFormElement>('.js-my-orders-ajax-load-form').forEach($form => {
        new MyOrdersAjaxLoad($form);
    });
}

class MyOrdersAjaxLoad {
    $form: HTMLFormElement;
    $formNbPerPagesInput: HTMLSelectElement; // The select inside the form to choose the nb of orders to disply per pages
    $ordersContainer: HTMLElement|null;
    $ordersLoader: HTMLElement|null = null;
    nbOrdersPerPages: number = 0; // The nb of orders returned by the server at each calls
    nbOrdersAsyncToLoad: number = 0; // The nb of orders to load asynchronously
    maxPage: number = 0;
    nbAjaxCalls: number = 0;
    filters: string = '';
    currentPage: number = 0;
    nextAjaxCallIndexToInsert: number = 1;
    ajaxCallStored: { [key: string]: string } = {}; // The ajax results stored (key = ajax call index | value = html of orders)

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$formNbPerPagesInput = this.$form.querySelector('select') as HTMLSelectElement;
        this.$ordersContainer = document.querySelector<HTMLElement>(this.$form.dataset.ordersContainerSelector as string);
        this.$formNbPerPagesInput.addEventListener('change', () => this.$form.submit());

        if (!this.$ordersContainer) {
            return;
        }

        this.$ordersLoader = document.querySelector<HTMLElement>('.js-orders-loader');
        this.nbOrdersPerPages = parseInt(this.$form.dataset.nbOrdersPerPages as string);
        this.nbOrdersAsyncToLoad = parseInt(this.$form.dataset.nbOrdersAsyncToLoad as string);
        this.maxPage = parseInt(this.$form.dataset.maxPage as string);
        this.nbAjaxCalls = Math.ceil(this.nbOrdersAsyncToLoad / this.nbOrdersPerPages);
        this.filters = this.$form.dataset.filters as string;
        this.currentPage = parseInt(this.$form.dataset.currentPage as string);

        // Change the nb of ajax calls to execute if the maxPage is excedeed
        for (let i = 1; i <= this.nbAjaxCalls; i++) {
            if (this.currentPage + i >= this.maxPage) {
                this.nbAjaxCalls = i;
                break;
            }
        }

        // Make the ajax calls
        for (let i = 1; i <= this.nbAjaxCalls; i++) {
            this.$ordersLoader?.classList.remove('hidden');
            this.doAjaxForPage(i, this.currentPage);

            this.currentPage++;
        }
    }

    /**
     * Make the ajax call for a specific page
     * 
     * @param {number} ajaxCallIndex
     * @param {number} page
     * 
     * @return {void}
     */
    doAjaxForPage(ajaxCallIndex: number, page: number) : void {
        getData(scriptVar.ajaxUrl, {
            action: 'get_orders_paginated_with_filters',
            filters: this.filters,
            current_page: page.toString(),
        }).then(response => {
            if (response.success) {
                this.ajaxCallStored[ajaxCallIndex] = response.data.html;
                this.insertOrders();
            } else {
                this.doAjaxForPage(ajaxCallIndex, page);
            }
        }).catch(() => {
            this.doAjaxForPage(ajaxCallIndex, page);
        });
    }

    /**
     * Insert orders into the DOM
     * 
     * @return {void}
     */
    insertOrders() : void {
        if (typeof this.ajaxCallStored[this.nextAjaxCallIndexToInsert] !== 'undefined') {
            // Create temporary div to append each children into the orders container
            const $tempContainer = document.createElement('div');
            $tempContainer.innerHTML = this.ajaxCallStored[this.nextAjaxCallIndexToInsert];
            while ($tempContainer.children.length > 0) {
                this.$ordersContainer?.append($tempContainer.children[0]);
            }

            this.nextAjaxCallIndexToInsert++;

            if (this.nextAjaxCallIndexToInsert > this.nbAjaxCalls) {
                this.$ordersLoader?.classList.add('hidden');
            } else {
                this.insertOrders();
            }
        }
    }
}
